export default {
	title: "Tipos de Atención",
	medium: "Médium",
	guide: "Guía",
	numberingMode: "Modo de Visualización",
	maxTickets: "Máx. Fichas",
	tracksTime: "Controla Tiempo",
	hasQueue: "Tiene Cola",
	status: "Estado",
	createdAt: "Creado en",
	updatedAt: "Actualizado en",
	details: {
		configuration: "Configuración",
		linkedRitualTypes: "Tipos de Rituales Vinculados",
		noLinkedRitualTypes: "Ningún tipo de ritual vinculado",
	},
	edit: "Editar Tipo de Atención",
	create: "Crear Tipo de Atención",
	delete: "Eliminar Tipo de Atención",
	activate: "Activar",
	deactivate: "Desactivar",
	viewDetails: "Ver Detalles",
	deleteConfirmation: "¿Desea realmente eliminar el tipo de atención {label}?",
	form: {
		code: {
			label: "Código",
			placeholder: "Ej: A, B, PAS, PRES",
			hint: "Código corto de la ficha (prefijo del fullCode)",
		},
		label: {
			label: "Nombre de la Ficha",
			placeholder: "Ej: Consulta Caboclo Pena Branca",
			hint: "Nombre descriptivo del tipo de atención",
		},
		medium: {
			label: "Médium Predeterminado",
			hint: "Médium que atenderá en esta ficha por defecto",
		},
		guide: {
			label: "Guía Espiritual (opcional)",
			placeholder: "Seleccione un guía",
			hint: "Guía espiritual asociado a esta atención (no obligatorio)",
		},
		numberingMode: {
			label: "Modo de Visualización",
		},
		maxTickets: {
			label: "Máximo de Fichas",
			hint: "Cantidad máxima de fichas (obligatorio para modo Fija)",
		},
		tracksTime: {
			label: "Controlar Tiempo",
			hint: "Registrar tiempo de inicio y fin de la atención",
		},
		hasQueue: {
			label: "Tiene Cola",
			hint: "Las fichas se llaman en orden (desmarque para presencia/registro simple)",
		},
	},
	numberingModes: {
		INCREMENTAL: "Bajo demanda",
		PRE_DEFINED: "Fija",
		incrementalDescription: "Fichas agregadas de a una, según demanda",
		preDefinedDescription: "Muestra todas las fichas de 1 a N a la vez",
	},
	messages: {
		created: "Tipo de atención {label} creado con éxito",
		updated: "Tipo de atención {label} actualizado con éxito",
		deleted: "Tipo de atención {label} eliminado con éxito",
		activated: "Tipo de atención {label} activado con éxito",
		deactivated: "Tipo de atención {label} desactivado con éxito",
		createError: "Error al crear tipo de atención",
		updateError: "Error al actualizar tipo de atención",
		deleteError: "Error al eliminar tipo de atención",
		loadError: "Error al cargar tipos de atención",
		toggleError: "Error al cambiar el estado del tipo de atención",
	},
	searchPlaceholder: "Código, nombre o guía...",
	loading: "Cargando detalles...",
	filters: {
		status: {
			all: "Todos",
		},
	},
	table: {
		code: "Código",
		label: "Nombre",
		medium: "Médium",
		guide: "Guía",
		numberingMode: "Modo de Visualización",
		linkedRitualTypes: "Vinculaciones",
		status: "Estado",
	},
	empty: {
		title: "Ningún tipo de atención encontrado",
		description: "Registre los tipos de ficha de atención para sus rituales",
	},
	stats: {
		total: "Tipos",
		active: "Activos",
	},
	buttons: {
		create: "Nuevo Tipo de Atención",
		delete: "Eliminar",
	},
	validation: {
		codeRequired: "El código es obligatorio",
		codeMaxLength: "El código debe tener máximo 4 caracteres",
		labelRequired: "El nombre es obligatorio",
		labelMaxLength: "El nombre debe tener máximo 100 caracteres",
		maxTicketsRequired: "La cantidad máxima es obligatoria para el modo Fija",
		maxTicketsMin: "La cantidad mínima es 1",
	},
};
